export default "__VITE_ASSET__D6KqpKL0__"